import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ warehouseTransfer, beginDate, endDate, branchOptions }) => {
    return (
        <div id="taxSummaryReport">
            {
                warehouseTransfer && warehouseTransfer.list && warehouseTransfer.list.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    //If there's DATA
                    <div>
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""
                                }
                            </div>
                        </div>
                        <div>
                            {warehouseTransfer && warehouseTransfer.list && warehouseTransfer.list.length > 0 &&
                                warehouseTransfer.list.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h5 className="m-0">{moment(item.date).format('MMMM Do, YYYY HH:mm')}</h5>
                                            </div>{/* row - Date */}
                                            <div className="row">
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 border-right">
                                                    <label className="m-0 money size_1-1vmax">Product: {item.productName}</label>
                                                </div> {/* Column Orders */}
                                                <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6 border-right mt-1">
                                                    <label>Category</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.productCategory}</h3>
                                                </div> {/* Column Orders */}
                                                {item.warehouse ?
                                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 border-right mt-1">
                                                        <label className="sm_label">Warehouse</label>
                                                        <h3 className="m-0 grey-text size_1-1vmax">{item.warehouse}</h3>
                                                    </div>
                                                    : ""}
                                                <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 border-right mt-1">
                                                    <label className="sm_label">SKU</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.sku}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-1 col-md-2 col-sm-4 col-xs-6 border-right mt-1">
                                                    <label className="sm_label">Quantity</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.quantity}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 border-right mt-1">
                                                    <label className="sm_label">Total Cost</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">${item.totalCost}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 mt-1">
                                                    <label className="sm_label">Status</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.action}</h3>
                                                </div> {/* Column Orders */}
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 border-right mt-1">
                                                    <label className="sm_label">Originating Branch</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.fromBranch}</h3>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-4 col-xs-6 mt-1">
                                                    <label className="sm_label">Receiving Branch</label>
                                                    <h3 className="m-0 grey-text size_1-1vmax">{item.toBranch}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
            }
        </div>
    );
};

export default Body;